// ToDo: не понятно почему последние 4 пункта попали в категории (переписать)?
export enum Category {
  MENU = 'Меню',
  APPS = 'Приложения',
  GAMES = 'Игры',
  DEVS = 'Разработчикам',
  SUPPORT = 'Помощь',
  ALL_APPS = 'Все приложения',
  ALL_GAMES = 'Все игры',
  KIOSK = 'Киоск',
}
